import React, { FC } from 'react';
import { WizardFormData, StepErrors } from '../types';

export interface StepEmailProps {
    formData: WizardFormData;
    errors: StepErrors;
    onChange: (field: keyof WizardFormData, value: any) => void;
}

/**
 * Step 0 — Email, First Name, and Last Name entry.
 * Renders plain HTML inputs with inline validation error display
 * and accessibility attributes for screen readers.
 */
const Step0_Email: FC<StepEmailProps> = ({ formData, errors, onChange }) => {
    return (
        <div className="wizard-step wizard-step-email">
            <div className="wizard-field">
                <label className="user_list_title" htmlFor="email">
                    Email:
                </label>
                <input
                    id="email"
                    type="email"
                    className="dropdown-input"
                    placeholder="Enter email address"
                    value={formData.email}
                    onChange={(e) => onChange('email', e.target.value)}
                    aria-describedby={errors.email ? 'email-error' : undefined}
                    aria-invalid={!!errors.email}
                    style={errors.email ? { borderColor: 'red' } : undefined}
                />
                {errors.email && (
                    <span id="email-error" className="wizard-field-error" role="alert">
                        {errors.email}
                    </span>
                )}
            </div>

            <div className="wizard-field">
                <label className="user_list_title" htmlFor="firstname">
                    First Name:
                </label>
                <input
                    id="firstname"
                    type="text"
                    className="dropdown-input"
                    placeholder="Enter first name"
                    value={formData.firstname}
                    onChange={(e) => onChange('firstname', e.target.value)}
                    aria-describedby={errors.firstname ? 'firstname-error' : undefined}
                    aria-invalid={!!errors.firstname}
                    style={errors.firstname ? { borderColor: 'red' } : undefined}
                />
                {errors.firstname && (
                    <span id="firstname-error" className="wizard-field-error" role="alert">
                        {errors.firstname}
                    </span>
                )}
            </div>

            <div className="wizard-field">
                <label className="user_list_title" htmlFor="lastname">
                    Last Name:
                </label>
                <input
                    id="lastname"
                    type="text"
                    className="dropdown-input"
                    placeholder="Enter last name"
                    value={formData.lastname}
                    onChange={(e) => onChange('lastname', e.target.value)}
                    aria-describedby={errors.lastname ? 'lastname-error' : undefined}
                    aria-invalid={!!errors.lastname}
                    style={errors.lastname ? { borderColor: 'red' } : undefined}
                />
                {errors.lastname && (
                    <span id="lastname-error" className="wizard-field-error" role="alert">
                        {errors.lastname}
                    </span>
                )}
            </div>
        </div>
    );
};

export default Step0_Email;
